import { useCallback } from 'react'
import { useIntercom } from 'react-use-intercom'
import config from 'config'

const useCustomerSupportWidget = () => {
  const { boot, shutdown, hide: hideIntercom, update, show: showIntercom } = useIntercom()

  const initiate = useCallback(
    user => {
      if (config.isProd) {
        boot({
          alignment: 'left',
          horizontalPadding: 28,
          verticalPadding: 33,
          hideDefaultLauncher: true,
          userId: user.id,
          email: user.email,
          name: user.name,
          phone: user.phoneNumber,
          avatar: {
            type: 'avatar',
            image_url: user.profileImage,
          },
          customAttributes: {
            job_title: user.profile?.occupation,
            type: user.Host?.id ? 'host' : 'normal_user',
            birth_date: user.birthdate,
            login_method: user.authMethod,
            education: user.profile?.education,
            bio: user.profile?.bio,
            location: user.location,
            gender: user.gender,
            preference: user.preference,
            currency: user.profile?.currency,
            timezone: user.timezone,
            sexualOrientation: user.sexualOrientation,
          },
        })
      }
    },
    [boot]
  )

  const show = useCallback(() => {
    update({
      hideDefaultLauncher: true,
    })
    showIntercom()
  }, [showIntercom, update])

  const hide = useCallback(() => {
    hideIntercom()
    update({
      hideDefaultLauncher: true,
    })
  }, [hideIntercom, update])

  return {
    initiate,
    show,
    hide,
    shutdown,
  }
}

export default useCustomerSupportWidget
